import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { JVInput } from "../../../shared/JVInput";
import { Dropdown } from "primereact/dropdown";


export interface IRecRepFilter {
    fromDate?: Date | null,
    ToDate?: Date | null,
    report_Type?: string | null,
    status?: string | null,
    added_By?: string | null,
    branch_ID?: number | null,
    company_ID?: number | null,
    // consultant_Name?:string | null,
}

export const EmptyRecRepFilter: IRecRepFilter = {
    fromDate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    ToDate: new Date(),
    report_Type: "",
    status: null,
    branch_ID: null,
    company_ID: null,
    // consultant_Name:""
}


interface Iprops {
    filter: IRecRepFilter,
    setFilter: (salEffFilter: IRecRepFilter) => void,
    onSearch:()=> void,
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [selectedIHUser, setselectedIHUser] = useState<any | null>(null);
    const [inHouseUser, setIHUser] = useState<Array<any>>();
    const [selecteduser, setselectedUser] = useState<any | null>(null);
    const [user, setUser] = useState<Array<any>>();

    const Report_Type = [
        { name: "--Select--" },
        { name: "SubVendor" },
        { name: "Consultant" },
        { name: "InHouse", },
    ]

    const { control, handleSubmit, reset, watch } = useForm<IRecRepFilter>({
        defaultValues: props.filter,
        shouldFocusError: false
    });
    const selectedReportType = watch("report_Type");

    const loadSales = async () => {
        const response = await Fetch("Dropdown/InHouseUserList", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setIHUser(data);
        }
    }

    const loadUser = async () => {
        let queryParameter = null;
        if (selectedReportType == "SubVendor") { queryParameter = `user_Type=${3}` } else {
            queryParameter = `user_Type=${2}`
        }
        const response = await Fetch("Dropdown/getSubConsultantList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUser(data);
        }
    }

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const searchToDB = async (body: IRecRepFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyRecRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setFilter(body);
    }

    function onSubmit(data: IRecRepFilter) {
        if (selectedReportType == "InHouse") {
            data.added_By = selectedIHUser;
        } else {
            data.added_By = selecteduser;
        }
        searchToDB(data);
        props.onSearch();
    }

    useEffect(() => {
        loadCompanies();
        loadBranches();
        loadSales();
    }, []);

    useEffect(() => {
        loadUser();
    }, [selectedReportType]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    loadBranches(value.company_ID);
                } else {
                    loadBranches();
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="ToDate" />
            <JVDropdown column={6} label="User Type" control={control} name="report_Type" options={Report_Type} optionLabel="name" optionValue="name" placeholder="Select Report Type" />
            {selectedReportType === "InHouse" && <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Users</label>
                <Dropdown value={selectedIHUser} onChange={(e) => {
                    console.log(e);
                    setselectedIHUser(e.value);
                }} options={inHouseUser} optionLabel="user_Name" placeholder="Select Users" optionValue="login_ID"
                    filter className="w-full" />
            </div>}
            {(selectedReportType === "SubVendor" || selectedReportType === "Consultant") && <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Users</label>
                <Dropdown value={selecteduser} onChange={(e) => {
                    setselectedUser(e.value);
                }} options={user} optionLabel="user_Name" placeholder="Select Users" optionValue="login_ID"
                    filter className="w-full" />
            </div>}
            {/* <JVInput column={6} label="Consultant Name" type="text" control={control} name="consultant_Name" /> */}
            <JVDropdown column={6} label="Status:" control={control} name="status" options={[
                { name: "--SELECT--" },
                { name: "Pending" },
                { name: "Verified" },
                { name: "Rejected" },
            ]} optionLabel="name" optionValue="name" placeholder="Select Status" />
            <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>       

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyRecRepFilter); setselectedUser(null); setselectedIHUser(null); }} type="button"></Button>
            </div>
        </form>
    );
}
